<section id="forgot-password" class="login-page forgot-password-page">
  <div class="login-grid">

    <div class="login-form-col">
      <div class="login-form-shell">
        <div class="login-brand">
          <img src="/assets/img/brand/mymeds-logo-mark.svg" alt="MyMedsPH" class="login-brand-mark" />
          <span class="login-brand-name">
            <span class="login-brand-name-orange">MyMeds</span><span class="login-brand-name-blue">PH</span>
          </span>
        </div>

        <header class="login-greeting">
          <h1>Forgot Password?</h1>
          <p>Enter your email address and we will send you instructions to reset your password.</p>
        </header>

        <form
          name="form"
          class="login-form"
          (ngSubmit)="f.form.valid && onSubmit()"
          #f="ngForm"
          novalidate>
          <div class="login-field">
            <label for="forgot-email">Email</label>
            <input
              type="email"
              class="form-control"
              name="email"
              id="forgot-email"
              [(ngModel)]="model.email"
              #email="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              required
              email
              autocomplete="email"
              placeholder="you@clinic.com" />
            <div *ngIf="f.submitted && email.invalid" class="forgot-field-error" role="alert">
              <span *ngIf="email.errors?.required">Email is required.</span>
              <span *ngIf="email.errors?.email && !email.errors?.required">Enter a valid email address.</span>
            </div>
          </div>

          <button type="submit" class="login-submit btn btn-info btn-block btn-raised" [disabled]="submitted">
            <span *ngIf="!submitted">Send reset link</span>
            <span *ngIf="submitted"><i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i> Sending…</span>
          </button>
        </form>

        <footer class="login-footer">
          <a routerLink="/auth/login" class="login-forgot">Back to sign in</a>
        </footer>
      </div>
    </div>

    <aside class="login-brand-panel" aria-hidden="true">
      <div class="brand-panel-glow"></div>
      <div class="brand-panel-mark">
        <img src="/assets/img/brand/mymeds-logo-mark.svg" alt="" />
      </div>
      <div class="brand-panel-content">
        <p class="brand-panel-eyebrow">Account recovery</p>
        <h2>Get Back Into Your Clinic Dashboard</h2>
        <p>We will email you a secure link so you can choose a new password and sign in again.</p>
        <ul class="brand-panel-features">
          <li><i class="fas fa-envelope" aria-hidden="true"></i><span>Reset link sent to your registered email</span></li>
          <li><i class="fas fa-shield-alt" aria-hidden="true"></i><span>Secure, time-limited recovery process</span></li>
          <li><i class="fas fa-sign-in-alt" aria-hidden="true"></i><span>Return to sign in when you are ready</span></li>
        </ul>
      </div>
      <div class="brand-panel-footer">
        <span>© {{ today | date:'y' }} MyMedsPH</span>
        <a href="https://mymedsph.com" target="_blank" rel="noopener noreferrer">mymedsph.com</a>
      </div>
    </aside>

  </div>
</section>
